import React, { Component } from 'react'
import Input from '../../components/UI/Input/Input'
import Button from '../../components/UI/Button/Button'
import FetchData from '../../shared/fetchData'
import { updateObject, checkValidity } from '../../shared/utility'
import "./ChangePassword.css"

class ChangePassword extends Component {

    state = {
        controls: {
            oldPassword: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'رمز عبور فعلی'
                },
                validation: {
                    required: true
                },
                errorMessage: 'فیلد الزامی است',
                valid: true,
                value: ''
            },
            newPassword: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'رمز عبور جدید'
                },
                validation: {
                    required: true
                },
                errorMessage: 'فیلد الزامی است',
                valid: true,
                value: ''
            },
            repeatPassword: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'تکرار رمز عبور'
                },
                validation: {
                    required: true
                },
                errorMessage: 'فیلد الزامی است',
                valid: true,
                value: ''
            }
        },
        showError: false,
        errorContent: '',
    }

    inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(this.state.controls, {
            [controlName]: updateObject(this.state.controls[controlName], {
                value: event.target.value,
                valid: checkValidity(event.target.value, this.state.controls[controlName].validation),
                errorMessage: this.state.controls[controlName].elementConfig.placeholder + ' صحیح نیست'
            })
        });
        this.setState({ controls: updatedControls });
    }

    changePassSubmit = (event) => {
        this.setState({ showError: false })
        const controls = this.state.controls
        let valid = true
        for (let key in controls) {
            if (controls[key].value == '') {
                valid = false
                controls[key].valid = false
            }
        }
        if (controls['repeatPassword'].value !== controls['newPassword'].value) {
            valid = false;
            controls['repeatPassword'].valid = false;
            controls['repeatPassword'].errorMessage = 'تکرار رمز عبور صحیح نیست';
        }
        if (valid == true) {
            const userId = window.localStorage.getItem("userId")
            var raw = JSON.stringify({ "userId": userId, "newPass": this.state.controls.newPassword.value, "oldPass": this.state.controls.oldPassword.value, "version": "mtpx001" })
            var url = 'management/api/v1/users/changeMyPass'
            FetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == '0') {
                        this.props.closeModal();
                    } else if (result.message == 'INVALID_INPUT') {
                        const content = <div className='row justify-content-center'>
                            <div className='pass-error'>
                                ورودی نا معتبر
                            </div>
                        </div>
                        this.setState({ showError: true, errorContent: content })
                    } else if (result.message == 'INVALID_PASSWORD') {
                        const content = <div className='row justify-content-center'>
                            <div className='pass-error'>
                                رمز عبور فعلی صحیح نیست
                            </div>
                        </div>
                        this.setState({ showError: true, errorContent: content })
                    }
                })
                .catch(error => console.log(error))
        } else {
            this.setState({ controls })
        }
    }

    render() {
        const formElementsArray = [];
        for (let key in this.state.controls) {
            formElementsArray.push({
                id: key,
                config: this.state.controls[key]
            });
        }
        let form = formElementsArray.map(formElement => {
            return (
                <Input
                    key={formElement.id}
                    elementType={formElement.config.elementType}
                    elementConfig={formElement.config.elementConfig}
                    value={formElement.config.value}
                    invalid={!formElement.config.valid}
                    shouldValidate={formElement.config.validation}
                    placeholder={formElement.config.placeholder}
                    errorMessage={formElement.config.errorMessage}
                    col="12 mt-3"
                    changed={(event) => this.inputChangedHandler(event, formElement.id)} />
            );
        });
        return (
            <div>
                {this.state.showError ?
                    <>
                        {this.state.errorContent}
                    </>
                    : ''}
                {form}
                <div className="row justify-content-center">
                    <Button btnType="Success" clicked={this.changePassSubmit}>ثبت</Button>
                </div>
            </div>
        )
    }
}

export default ChangePassword